var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.options.length)?_c('base-select-filter',_vm._b({attrs:{"value":_vm.value,"options":_vm.options,"option-value":"id","option-label":"name"},on:{"input":inputValue => _vm.$emit('input', inputValue)}},'base-select-filter',_vm.$attrs,false),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }